export default __webpack_public_path__ + "static/media/metropolis-logo-sml.505a15fd.png";